"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.H2 = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const StyledH2 = styled_1.default.h2 `
	margin: 24px 0;
	font-size: 24px;
	font-family: RalewayTN;
	font-weight: 700;
	line-height: 125%;
	color: #11233a;
`;
const H2 = ({ text }) => {
    return react_1.default.createElement(StyledH2, null, text);
};
exports.H2 = H2;
//# sourceMappingURL=H2.js.map